import React, { useCallback } from 'react';

// helpers
import styled from 'styled-components';
import useTranslation from 'hooks/useTranslation';
import { signOut } from 'redux/actions/auth';
import { useDispatch } from 'react-redux';

// components
import SelectAccessContext from 'modules/AccessContext/SelectAccessContext';
import { Card, Link } from '@ui';

const SelectAccessContextPage = () => {
  const { t } = useTranslation('common');
  const dispatch = useDispatch();

  const handleSignOut = useCallback(() => {
    dispatch(signOut());
  }, []);

  return (
    <RootWrapper>
      <StyledCard marginTop="50px" cardWidth="60%">
        <SelectAccessContext />
        <FooterWrapper>
          <StyledLinkWrapper>
            <Link onClick={handleSignOut}>{t('sign_out')}</Link>
          </StyledLinkWrapper>
        </FooterWrapper>
      </StyledCard>
    </RootWrapper>
  );
};

const RootWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledLinkWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: ${({ theme }) => theme.marginXs};
`;

const StyledCard = styled<any>(Card)`
  display: flex;
  margin-top: ${({ marginTop }) => marginTop};
  height: auto;
  width: ${({ cardWidth }) => cardWidth};
  min-height: 355px;

  background: ${({ theme }) => theme.colorDarkD1};
  border-color: ${({ theme }) => theme.colorDarkL3};

  .ant-card-body {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 48px;
  }

  @media screen and (max-width: 576px) {
    width: 100%;
    height: 100%;
    margin-top: 0px;
    padding: 30px;
    padding-top: 100px !important;
    display: flex;
    flex-direction: column;
    align-items: center;

    .ant-card-body {
      width: 100%;
      padding: 10px;
    }
  }
`;

const FooterWrapper = styled.div`
  position: absolute;
  bottom: -24px;
  left: 50%;
  transform: translate(-50%, 12px);
`;

export default SelectAccessContextPage;
